


import React from "react";
import { Menu } from "antd";
import {
  HomeOutlined,
  BookOutlined,
  PhoneOutlined,
  PictureOutlined,
} from "@ant-design/icons";

const Header = () => {
  return (
    <header className="bg-pink-600"
      style={{
        // backgroundColor: "#001529",
        padding: "0 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: '100%',
      }}
    >
      
      {/* Menu for both mobile and desktop */}
      <div className="menu-container">
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["1"]}
          style={{ backgroundColor: "inherit", borderBottom: "none", width: '100%' }}
        >
          <Menu.Item key="1" icon={<HomeOutlined />} style={{fontWeight:"bold"}}>
            Home
          </Menu.Item>
          <Menu.Item key="2" icon={<BookOutlined />} style={{fontWeight:"bold"}}>
            Course
          </Menu.Item>
          <Menu.Item key="3" icon={<PhoneOutlined />} style={{fontWeight:"bold"}}>
            Contact
          </Menu.Item>
          <Menu.Item key="4" icon={<PictureOutlined />} style={{fontWeight:"bold"}}>
            Gallery
          </Menu.Item>
          {/* <Menu.Item key="5" icon={<InfoCircleOutlined />}>
            About
          </Menu.Item> */}
        </Menu>
      </div>
    </header>
  );
};

export default Header;

